module.exports = __webpack_public_path__ + "img/recruit.79a87efd.svg";